__webpack_require__.p = "/live_realtime_chatapp_f/";